import React, { FC, memo, ReactElement } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import i18next from 'i18next';
import AppModal from '../../../components/app-modal/AppModal';

type DeleteTrainingModalProps = {
  show: boolean;
  onPositive: (index: number) => void;
  onNegative: () => void;
  trainingIndex: number;
};

const DeleteTrainingModal: FC<DeleteTrainingModalProps> = ({ show, onPositive, onNegative, trainingIndex, }: DeleteTrainingModalProps): ReactElement => {
  return (
    <AppModal show={show} onHide={onNegative}>
      <Modal.Header closeButton>
        <Modal.Title>
          {i18next.t('trainingPlan.deleteTrainingTitle')}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {i18next.t('trainingPlan.deleteTrainingBody')}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          style={{ marginRight: 'auto' }}
          onClick={onNegative}
        >
          {i18next.t('generic.cancel')}
        </Button>

        <Button
          onClick={() => onPositive(trainingIndex)}
          variant="danger"
        >
          {i18next.t('generic.delete')}
        </Button>
      </Modal.Footer>
    </AppModal>
  );
};

export default memo(DeleteTrainingModal);
